import React from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../sections/Hero";
import { Impact } from "../sections/Impact";
import { About } from "../sections/About";
import { Services } from "../sections/Services";
import { PrivateIT } from "../sections/PrivateIT";
// import { Portfolio } from "../sections/Portfolio"; // oculto hasta rediseño
import { Press } from "../sections/Press";
import { FAQ } from "../sections/FAQ";
import { Contact } from "../sections/Contact";
import { Footer } from "../components/Footer";

export const HomePage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Impact />
      <About />
      <Services />
      <PrivateIT />
      <Press />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
};
